"use client";
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { domAnimation, LazyMotion, m } from "framer-motion";

const Loading = () => {
  const [portalContainer, setPortalContainer] = useState<HTMLElement | null>(
    null
  );
  useEffect(() => {
    if (typeof document !== "undefined") {
      setPortalContainer(document.body);
    }
  }, []);

  if (!portalContainer) return null;

  return createPortal(
    <LazyMotion features={domAnimation}>
      <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-md z-[2000]">
        <div className="flex flex-col items-center">
          {/* Spinner Animation */}
          <m.div
            className="w-14 h-14 border-4 border-transparent border-t-white rounded-full"
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
          ></m.div>

          {/* Loading Text */}
          <p className="text-white mt-4 text-lg font-semibold">Loading...</p>
        </div>
      </div>
    </LazyMotion>,
    portalContainer
  );
};

export default Loading;
